import { useQuery } from "@tanstack/react-query";
import { getPaymentMethods } from "@/api/v1-jwt/payment-methods/payment-methods";
import { useAuth } from "@/providers/auth";

export const useGetPaymentMethods = ({
  queryKey,
  queryFn,
  enabled,
  ...config
} = {}) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!userRole && !!id && enabled !== false;

  return useQuery({
    queryKey: ["payment_methods"],
    queryFn: async () =>
      await getPaymentMethods({ user_id: id, status: false }),
    enabled: isEnabled,
    ...config,
  });
};
